import React from 'react'
import { Space } from 'antd'

import lineLogo from '/images/base/line-logo.png?url'
import SegmentTag from '../../../Customers/CustomerLifetimeValue/SegmentTag'

import {
  UserOutlined,
  PhoneOutlined,
  ShopOutlined,
  MailOutlined,
  EditOutlined,
  TagOutlined,
  ManOutlined,
  PlusCircleOutlined
} from '@ant-design/icons'

const Field = ({ icon, value, fallback = '-', href }) => {
  const content = value || fallback
  return (
    <div className='customer-field'>
      <span className='field-icon'>{icon}</span>
      {value && href
        ? <a href={href} rel='noreferrer' target='_blank'>{content}</a>
        : <span>{content}</span>}
    </div>
  )
}

// Company field: link every company the customer belongs to. `customer_companies`
// normalizes to a list of company ids (names live in the customerCompanies
// entities); we fall back to the pre-joined `company_name` string when the
// entities aren't loaded.
const renderCompanies = (customerEntity, companyEntities) => {
  const raw = customerEntity.get('customer_companies')
  const list = raw ? raw.toJS() : []
  const nodes = list
    .map((c) => {
      if (c && typeof c === 'object') return { id: c.id, name: c.name || c.company_name }
      const co = companyEntities && (companyEntities.get(c) || companyEntities.get(String(c)))
      return { id: c, name: co ? co.get('name') : null }
    })
    .filter((c) => c.id != null && c.name)

  if (!nodes.length) {
    return <span>{customerEntity.get('company_name') || '-'}</span>
  }
  return (
    <span>
      {nodes.map((c, i) => (
        <React.Fragment key={c.id}>
          {i > 0 && ', '}
          <a href={`/companies/${c.id}`} rel='noreferrer' target='_blank'>{c.name}</a>
        </React.Fragment>
      ))}
    </span>
  )
}

const CustomerCard = ({
  orderEntity,
  customerEntities,
  companyEntities
}) => {
  const customerId = orderEntity.getIn(['customer', 'id'])
  const customerEntity = customerEntities.get(customerId)

  if (!customerId || !customerEntity) {
    return null
  }

  const id = customerEntity.get('id')
  const fullName = `${customerEntity.get('first_name')} ${customerEntity.get('last_name') || ''}`.trim()
  const labels = customerEntity.get('customer_labels')
  const labelText = labels && labels.size > 0
    ? labels.map((l) => l.get('label')).join(', ')
    : '-'

  return (
    <div className='customer-compact'>
      <div className='customer-header'>
        <a href={`/customers/${id}`} rel='noreferrer' target='_blank' className='customer-name'>
          <strong>{fullName}</strong>
        </a>
        <a href={`/customers/${id}/edit`} rel='noreferrer' target='_blank'>
          <EditOutlined />
        </a>
        <SegmentTag customerId={id} showInfoIcon={false} />
        <span className='customer-id-link'>
          <a href={`/customers/${id}`} rel='noreferrer' target='_blank'>
            <UserOutlined /> {id}
          </a>
        </span>
        {customerEntity.get('line_url') && (
          <a href={customerEntity.get('line_url')} rel='noreferrer' target='_blank'>
            <img src={lineLogo} height={14} alt='line icon'/>
          </a>
        )}
        <a href={`/customers/${id}/orders/new`} rel='noreferrer' target='_blank' className='new-order-link'>
          <PlusCircleOutlined /> ออเดอร์ใหม่
        </a>
      </div>

      <div className='customer-grid'>
        <Field icon={<PhoneOutlined rotate={90} />}
          value={customerEntity.get('phone_number')}
          href={`tel:${customerEntity.get('phone_number')}`} />
        <Field icon={<MailOutlined />} value={customerEntity.get('email')} />
        <div className='customer-field'>
          <span className='field-icon'><ShopOutlined /></span>
          {renderCompanies(customerEntity, companyEntities)}
        </div>
        <Field icon={<ManOutlined />} value={customerEntity.get('gender')} />
        <Field icon={<TagOutlined />} value={labelText !== '-' ? labelText : null} />
      </div>

      {customerEntity.get('customer_note') && (
        <div className='customer-note'>
          {customerEntity.get('customer_note')}
        </div>
      )}
    </div>
  )
}

export default CustomerCard
